<template>
	<div v-if="open" class="modal is-active statistics-map-modal">
		<div class="modal-background" @click="$emit('close')"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">{{ title || $t('statistics.drawing') }}</p>
				<button class="delete" aria-label="close" @click="$emit('close')"></button>
			</header>
			<section class="modal-card-body">
				<div v-if="loading" class="statistics-empty compact">
					{{ $t('statistics.loading_drawing') }}
				</div>
				<div v-else-if="image && item && hasInventoryMapPosition(item)" class="statistics-map-dialog-canvas">
					<img
						:src="image"
						:alt="title || $t('statistics.drawing')"
						draggable="false"
					/>
					<div
						class="statistics-map-marker"
						:style="getInventoryMapMarkerStyle(item)"
						:title="getInventoryName(item)"
					>
						<div
							class="statistics-map-inventory-icon"
							:class="getInventoryMapIconClass(item)"
						></div>
					</div>
				</div>
				<div v-else class="statistics-empty compact">
					{{ error || $t('statistics.drawing_or_position_missing') }}
				</div>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StatisticsMapModal',

	props: {
		error: {
			type: String,
			default: ''
		},
		getInventoryMapIconClass: {
			type: Function,
			required: true
		},
		getInventoryMapMarkerStyle: {
			type: Function,
			required: true
		},
		getInventoryName: {
			type: Function,
			required: true
		},
		hasInventoryMapPosition: {
			type: Function,
			required: true
		},
		image: {
			type: String,
			default: ''
		},
		item: {
			type: Object,
			default: null
		},
		loading: {
			type: Boolean,
			default: false
		},
		open: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		}
	}
};
</script>
